var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9999 0C9.8694 0 0 9.8694 0 21.9999C0 34.1304 9.8694 43.9998 21.9999 43.9998C34.1304 43.9998 43.9998 34.1304 43.9998 21.9999C43.9998 9.8694 34.1304 0 21.9999 0ZM28.2894 23.1636C26.6637 24.4016 24.6363 25.1388 22.4409 25.1388H21.5583C19.3622 25.1388 17.3344 24.4015 15.7099 23.1636C10.6109 23.9879 6.68116 28.2697 6.38085 33.5263C3.99744 30.3026 2.587 26.3168 2.587 21.9999C2.587 11.2784 11.2779 2.58761 21.9993 2.58761C32.7208 2.58761 41.4116 11.2782 41.4116 21.9999C41.4116 26.3162 40.0008 30.3021 37.6177 33.5263C37.3187 28.2701 33.389 23.9878 28.2896 23.1636H28.2894Z",
    fill: "#7A5AF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 23.0772C26.6195 23.0772 30.3772 18.174 30.3772 13.5552C30.3772 8.93576 26.6195 5.177 22.0001 5.177C17.3806 5.177 13.6226 8.93576 13.6226 13.5552C13.6229 18.1743 17.3806 23.0772 22.0001 23.0772Z",
    fill: "#7A5AF8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatar);
export default __webpack_public_path__ + "static/media/DefaultAvatar.a556fd242883ed251ce59208025c0064.svg";
export { ForwardRef as ReactComponent };